export const spanishFormatMappings: Record<string, string> = {
  // Grammatically correct Spanish dates use "de" connectors between day, month, and year
  // for example: "14 de enero de 2025", "lunes 14 de enero de 2025"
  // Long month formats with full weekday
  'iiii, MMMM d, yyyy': "iiii d 'de' MMMM 'de' yyyy",
  'iiii, MMMM do, yyyy': "iiii d 'de' MMMM 'de' yyyy",
  'EEEE, MMMM d, yyyy': "EEEE d 'de' MMMM 'de' yyyy",
  'EEEE, MMMM do, yyyy': "EEEE d 'de' MMMM 'de' yyyy",
  'iiii MMMM d, yyyy': "iiii d 'de' MMMM 'de' yyyy",
  'EEEE MMMM d, yyyy': "EEEE d 'de' MMMM 'de' yyyy",

  // Long month formats without weekday
  'MMMM d, yyyy': "d 'de' MMMM 'de' yyyy",
  'MMMM do, yyyy': "d 'de' MMMM 'de' yyyy",
  'd MMMM, yyyy': "d 'de' MMMM 'de' yyyy",
  'yyyy, MMMM d': "d 'de' MMMM 'de' yyyy",
  'yyyy MMMM d': "d 'de' MMMM 'de' yyyy",

  // Short month formats with full weekday
  'iiii, MMM d, yyyy': "iiii d 'de' MMM 'de' yyyy",
  'iiii, MMM do, yyyy': "iiii d 'de' MMM 'de' yyyy",
  'EEEE, MMM d, yyyy': "EEEE d 'de' MMM 'de' yyyy",
  'EEEE, MMM do, yyyy': "EEEE d 'de' MMM 'de' yyyy",
  'iiii MMM d, yyyy': "iiii d 'de' MMM 'de' yyyy",
  'EEEE MMM d, yyyy': "EEEE d 'de' MMM 'de' yyyy",

  // Short month formats without weekday
  'MMM d, yyyy': "d 'de' MMM 'de' yyyy",
  'MMM do, yyyy': "d 'de' MMM 'de' yyyy",
  'd MMM, yyyy': "d 'de' MMM 'de' yyyy",
  'yyyy, MMM d': "d 'de' MMM 'de' yyyy",
  'yyyy MMM d': "d 'de' MMM 'de' yyyy",

  // 2-digit year variations
  'MMMM d, yy': "d 'de' MMMM 'de' yy",
  'MMM d, yy': "d 'de' MMM 'de' yy",
  'd MMMM, yy': "d 'de' MMMM 'de' yy",
  'yy, MMMM d': "d 'de' MMMM 'de' yy",
  'yy MMMM d': "d 'de' MMMM 'de' yy",
  'yy, MMM d': "d 'de' MMM 'de' yy",
  'yy MMM d': "d 'de' MMM 'de' yy",

  // Numeric formats
  'MM/dd/yyyy': 'dd/MM/yyyy',
  'M/d/yyyy': 'd/M/yyyy',
  'MM/dd/yy': 'dd/MM/yy',
  'M/d/yy': 'd/M/yy',
  'yyyy/MM/dd': 'dd/MM/yyyy',
  'yy/MM/dd': 'dd/MM/yy',

  // ISO and hyphenated formats
  'yyyy-MM-dd': 'dd-MM-yyyy',
  'yy-MM-dd': 'dd-MM-yy',
  'MM-dd-yyyy': 'dd-MM-yyyy',
  'M-d-yyyy': 'd-M-yyyy',

  // Dot formats
  'MM.dd.yyyy': 'dd.MM.yyyy',
  'M.d.yyyy': 'd.M.yyyy',
  'yyyy.MM.dd': 'dd.MM.yyyy',
}
